import { render, staticRenderFns } from "./CoranaMessage.vue?vue&type=template&id=3e865905&"
import script from "./CoranaMessage.vue?vue&type=script&lang=js&"
export * from "./CoranaMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports